function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoLoaderTemplate = require('./saito-loader.template');
var SaitoLoader = /*#__PURE__*/function () {
  function SaitoLoader(app, mod) {
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, SaitoLoader);
    this.app = app;
    this.mod = mod;
    this.container = container;
  }
  return _createClass(SaitoLoader, [{
    key: "show",
    value: function show() {
      var msg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.render(!this.container, msg);
    }
  }, {
    key: "hide",
    value: function hide() {
      this.remove();
    }
  }, {
    key: "render",
    value: function render() {
      var blocker = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var msg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var added = false;
      if (this.container) {
        if (!document.querySelector("".concat(this.container, " #saito-loader-container"))) {
          added = true;
          this.app.browser.addElementToSelector(SaitoLoaderTemplate(blocker, msg), this.container);
        }
      } else {
        if (!document.querySelector('#saito-loader-container')) {
          added = true;
          this.app.browser.prependElementToDom(SaitoLoaderTemplate(blocker, msg));
        }
      }
      if (!added) {
        this.app.browser.replaceElementById(SaitoLoaderTemplate(blocker, msg), 'saito-loader-container');
      }
    }
  }, {
    key: "remove",
    value: function remove() {
      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;
      var selector = this.container + ' #saito-loader-container';
      selector = selector.trim();
      if (document.querySelector(selector)) {
        document.querySelector(selector).classList.add('disappear');
        setTimeout(function () {
          // Still should test because may have been removed while not looking...
          if (document.querySelector(selector)) {
            document.querySelector(selector).remove();
          }
        }, delay);
      }
    }
  }]);
}();
module.exports = SaitoLoader;